import * as React from 'react';
import {styled} from '@mui/material/styles';
import Checkbox, {CheckboxProps} from '@mui/material/Checkbox';
import "./checkbox.scss";

const BpIcon = styled('span')(({theme}) => ({
    borderRadius: 3,
    backgroundColor: '#fff',
    backgroundImage:
        theme.palette.mode === 'dark'
            ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
            : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
}));

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#fff',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        content: '""',
    },
});

// Inspired by blueprintjs
export default function CheckBox(props: CheckboxProps) {
    return (
        <div className="Check-Box">
            <Checkbox
                sx={{
                    '&:hover': {bgcolor: 'transparent'},
                }}
                disableRipple
                color="default"
                checkedIcon={<BpCheckedIcon/>}
                icon={<BpIcon/>}
                inputProps={{'aria-label': 'Checkbox demo'}}
                {...props}
            />
        </div>
    );
}